/**
 * 数学除法。
 *
 * @category Mathematics
 *
 * @public
 *
 * @param value - 被除数。
 * @param operand - 除数。
 *
 * @returns 商。
 */
export function divide(value, operand) {
    return value / operand;
}
//# sourceMappingURL=divide.js.map